import { render, staticRenderFns } from "./TechnicalDrawing.vue?vue&type=template&id=5fd9ae8c&scoped=true&"
import script from "./TechnicalDrawing.vue?vue&type=script&lang=js&"
export * from "./TechnicalDrawing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd9ae8c",
  null
  
)

export default component.exports